    const checkNegativeProfileApi = async (
  apiHandler,
  endpoint,
  authToken,
  setCallInProgress,
  toastUpdate,
  aadharNumber,
  panNumber,
  mobileNumber,
) => {
  let value = "?";
  if (!aadharNumber && !panNumber && !mobileNumber) {
    return null;
  }
  if(aadharNumber) {
    value = value + "adhaar=" + aadharNumber;
  }
  if(panNumber) {
    if(value !== "?") {
      value = value + "&";
    }
    value = value + "pan=" + panNumber;
  }
  if(mobileNumber) {
    if(value !== "?") {
      value = value + "&";
    }
    value = value + "mobileNumber=" + mobileNumber;
  }
  setCallInProgress(true);

  try {
    const response = await apiHandler({
      url:
        endpoint.CHECK_NEGATIVE_REGISTER + value,
      authToken,
    });
    setCallInProgress(false);
    if (response?.data?.error_code) {
      toastUpdate("Error", response?.data?.user_description, true)
      return;
    }else{
        return response?.data;
    }
  } catch (error) {
    setCallInProgress(false);
    console.error("CheckNegativeRegister Error:", error);
  }
};

export default checkNegativeProfileApi;